import { LoadingButton } from "@mui/lab";
import {
  Box,
  IconButton,
  InputAdornment,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { useSnackbar } from "notistack";
import { useState, useEffect } from "react";
import Iconify from "src/components/Iconify";
import Scrollbar from "src/components/Scrollbar";
import { BodyRow } from "src/components/custom-table";
import DataHandlerList from "src/components/data-handler/list";
import EmptyTable from "src/components/emptyTable";
import Map from "src/components/map";
import Translate from "src/components/translate";
import useGetData from "./hooks/useGetData";
import { Icon } from "@iconify/react";

const HealthLevel = () => {
  const { state, setData, handleUpdate, handleDelete, onSubmit } = useGetData();
  const { data = [], ...dataProps } = state;

  const handleAddLevel = () => {
    const highestLevel =
      data.length > 0 ? Math.max(...data.map((item) => Number(item.level))) : 0;

    const highestId =
      data.length > 0 ? Math.max(...data.map((item) => Number(item.id))) : 0;

    const newRow = {
      id: highestId + 1,
      level: highestLevel + 1,
      percentage: "",
      isNew: true,
    };

    setData([...data, newRow]);
  };

  const latestLevel =
    data.length > 0 ? Math.max(...data.map((d) => Number(d.level))) : null;

  return (
    <Scrollbar>
      <DataHandlerList dataProps={{ ...dataProps }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <Translate>settings.network.level</Translate>
              </TableCell>
              <TableCell>
                <Translate>settings.network.level_bonus</Translate> (%)
              </TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            <Map
              list={data}
              render={(item) => (
                <Row
                  key={item.id}
                  {...item}
                  handleUpdate={handleUpdate}
                  handleDelete={handleDelete}
                  isLatest={Number(item.level) === latestLevel}
                />
              )}
            />
          </TableBody>
        </Table>

        <Box textAlign="right">
          <Box sx={{ display: "flex", justifyContent: "end", gap: 2, mt: 3 }}>
            <LoadingButton onClick={handleAddLevel} variant="contained">
              <Translate>{"Add"}</Translate>
            </LoadingButton>
            <LoadingButton onClick={onSubmit} variant="contained">
              <Translate>{"settings.network.update"}</Translate>
            </LoadingButton>
          </Box>
        </Box>
      </DataHandlerList>
    </Scrollbar>
  );
};

const Row = ({
  id,
  level,
  percentage,
  handleUpdate,
  handleDelete,
  isLatest,
}) => (
  <TableRow>
    <TableCell>
      <TextField type="text" size="small" value={`Level ${level}`} disabled />
    </TableCell>
    <TableCell>
      <LoadingTextField
        handleUpdate={handleUpdate(id)}
        value={percentage}
        name="percentage"
      />
    </TableCell>
    <TableCell align="center">
      {isLatest && (
        <IconButton onClick={() => handleDelete(id)}>
          <Icon icon="material-symbols:delete-outline" width="24" height="24" />
        </IconButton>
      )}
    </TableCell>
  </TableRow>
);

const LoadingTextField = ({ value, name, handleUpdate }) => {
  const [loading, setLoading] = useState(false);
  const onChange = (e) => {
    setLoading(true);
    handleUpdate(e);
    setTimeout(() => setLoading(false), 300);
  };

  return (
    <TextField
      onWheel={(e) => e.target.blur()}
      type="number"
      onChange={onChange}
      size="small"
      value={value}
      name={name}
    />
  );
};

export default HealthLevel;
